var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("contacts.contact_details") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "m-0 pb-3", attrs: { "no-gutters": "" } },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              staticClass: "form-accordion-subtitle",
              attrs: {
                title: _vm.$t("common.contact_ids"),
                isTitleUpperCase: false,
              },
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _vm.typeContact === "1"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "custom-control custom-radio custom-control-inline",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeContact,
                              expression: "typeContact",
                            },
                          ],
                          staticClass: "custom-control-input",
                          attrs: {
                            readonly: "",
                            type: "radio",
                            name: "inlineDefaultRadiosExample",
                            id: "defaultInline1",
                            value: "1",
                          },
                          domProps: { checked: _vm._q(_vm.typeContact, "1") },
                          on: {
                            change: function ($event) {
                              _vm.typeContact = "1"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label",
                            attrs: { for: "defaultInline1" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.indiv")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm.typeContact === "2"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "custom-control custom-radio custom-control-inline",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeContact,
                              expression: "typeContact",
                            },
                          ],
                          staticClass: "custom-control-input",
                          attrs: {
                            readonly: "",
                            type: "radio",
                            name: "inlineDefaultRadiosExample",
                            id: "defaultInline2",
                            value: "2",
                          },
                          domProps: { checked: _vm._q(_vm.typeContact, "2") },
                          on: {
                            change: function ($event) {
                              _vm.typeContact = "2"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label",
                            attrs: { for: "defaultInline2" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.cmpny_accnt")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.nme"),
                          inputValue: _vm.username ? _vm.username : "-",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.als"),
                          inputValue: _vm.label ? _vm.label : "-",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              this.$settings.currentContact.typeContact === "1"
                ? _c(
                    "b-row",
                    { staticClass: "group typeInd" },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "5" } },
                        [
                          _c("form-read-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t("common.eml"),
                              inputValue: _vm.identifier ? _vm.identifier : "-",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$settings.currentContact.typeContact === "2"
                ? _c(
                    "b-row",
                    { staticClass: "form-group typeCom" },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "5" } },
                        [
                          _c("form-read-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t("common.srn"),
                              inputValue: _vm.identifier ? _vm.identifier : "-",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c("b-col", { attrs: { sm: "11" } }, [
                _c("hr", { staticClass: "w-100" }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              staticClass: "form-accordion-subtitle",
              attrs: {
                title: _vm.$t("common.srtp_adress"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("contacts.ibn"),
                          inputValue: _vm.iban ? _vm.iban : "-",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t(
                            "common.recipient_srtp_id_provider"
                          ),
                          inputValue: _vm.idProvider ? _vm.idProvider : "-",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  this.$engine.user.currentService.id === "2"
                    ? _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { sm: "5" } },
                        [
                          _c(
                            "form-read-group-label-input",
                            {
                              attrs: {
                                inputLabel: _vm.$t("bank_accounts.mandat_id"),
                                inputValue: "",
                              },
                            },
                            [_vm._v(" ? ''\"> : '-'\n          ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              this.$engine.user.currentService.id === "2"
                ? _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "5" } },
                        [
                          _c(
                            "form-read-group-label-input",
                            {
                              attrs: {
                                inputLabel: _vm.$t("bank_accounts.mandat_date"),
                                inputValue: "",
                              },
                            },
                            [_vm._v(" ? ''\"> : '-'\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c("b-col", { attrs: { sm: "11" } }, [
                _c("hr", { staticClass: "w-100" }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              staticClass: "form-accordion-subtitle",
              attrs: {
                title: _vm.$t("common.formsSubTitle.extra_info"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.phn_nbr"),
                          inputValue: _vm.phoneNumber ? _vm.phoneNumber : "-",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.adrs"),
                          inputValue: _vm.address ? _vm.address : "-",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.cty"),
                          inputValue: _vm.city ? _vm.city : "-",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.zp_code"),
                          inputValue: _vm.zipCode ? _vm.zipCode : "-",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.cntry"),
                          inputValue: _vm.country ? _vm.country : "-",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasRight("contact_editer")
            ? _c(
                "b-row",
                {
                  staticClass: "form-group justify-content-end no-gutters",
                  attrs: { xl: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-3 pt-2",
                      attrs: {
                        variant: "primary",
                        size: "sm",
                        href: "/account/editContact/",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("contacts.edit_contact")) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.hasRight("contact_supprimer")
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mr-3",
                          attrs: {
                            variant: "primary",
                            size: "sm",
                            title: _vm.$t("common.rm_label"),
                          },
                          on: { click: _vm.removeContact },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("contacts.supp_contact")) +
                                "\n        "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }